module.exports = __webpack_public_path__ + "static/media/2.341968a0.jpg";